export const sizeTotal = (sizes = {}) => Object.values(sizes).reduce((sum, value) => sum + (Number(value) || 0), 0);
export const cleanSizes = (sizes = {}) => Object.fromEntries(Object.entries(sizes).filter(([, value]) => Number(value) > 0).map(([size, value]) => [size, Number(value)]));

export function sizeSelectionError(product, sizes, requiredQty = null) {
  const options = product?.size_options || [];
  if (!options.length) return "";
  if (Object.values(sizes).some((value) => !Number.isInteger(Number(value)) || Number(value) < 0)) return "Enter whole quantities of zero or more.";
  const total = sizeTotal(sizes);
  if (!total) return "Select at least one size.";
  if (Object.entries(sizes).some(([size, value]) => Number(value) > 0 && !options.includes(size))) return "Remove sizes that are no longer available.";
  if (requiredQty != null && total !== requiredQty) return `Size quantities must add up to ${requiredQty} pieces.`;
  if (total > 99999) return "The maximum quantity is 99,999 pieces.";
  return "";
}

export function itemConfigurationError(item) {
  if (item.product.unavailable) return "";
  const options = item.product.size_options || [];
  if (!options.length && Object.keys(item.size_quantities || {}).length) return "Size options have changed. Please edit this product's details.";
  return sizeSelectionError(item.product, item.size_quantities || {}, item.qty);
}

export function itemDetailsText(item) {
  const entries = Object.entries(item.size_quantities || {}).filter(([, qty]) => Number(qty) > 0);
  return [entries.length ? `Sizes: ${entries.map(([size, qty]) => `${size} × ${qty}`).join(", ")}` : "", item.details ? `Product details: ${item.details}` : ""].filter(Boolean).join("\n");
}